'use client';

export const realtimeReconnectRequestEventName = 'agentteams:realtime-reconnect-request';

export type RealtimeReconnectReason = 'app-resume' | 'online' | 'pull-to-refresh' | 'stale-heartbeat';

export const requestRealtimeReconnect = (reason: RealtimeReconnectReason): void => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(realtimeReconnectRequestEventName, { detail: { reason } }));
};
